module.exports = __webpack_public_path__ + "media/images/laureate-cert-3782283e1d6e74ad8480fa13b3ba4db4.jpg";